<!--  -->
<template>
  <div class="main">
    <div class="form-screen">
      <a-input-search
        placeholder="请输入物料名称"
        style="width: 240px"
        class="screen-option"
        enterButton
        @search="onSerch"
      ></a-input-search>
      <a-button type="primary" @click="editAdv('add')">添加物料</a-button>
    </div>
    <a-table
      :columns="columns"
      :rowKey="(record) => record.id"
      :dataSource="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="name" slot-scope="name">
        {{ name }}
      </template>
      <template slot="picture" slot-scope="picture, record">
        <img
          :src="picture"
          alt=""
          width="200"
          :height="ratioHeight(record.height)"
        />
      </template>
      <!-- <template slot="target" slot-scope="target">
        <span v-if="target == 1">新窗口</span>
        <span v-else>原窗口</span>
      </template> -->
      <template slot="size" slot-scope="record">
        <span>{{ record.width }}*{{ record.height }}</span>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a-button
          type="primary editable-add-btn"
          @click="editAdv('edit', record)"
        >
          <a-icon type="edit" />编辑
        </a-button>

        <a-popconfirm
          title="确认删除么"
          okText="确定"
          cancelText="取消"
          @confirm="del(record.id)"
        >
          <a-button type="danger" :style="{ marginLeft: '8px' }">
            <a-icon type="delete" />删除
          </a-button>
        </a-popconfirm>

        <a-button
          type=" editable-add-btn"
          :style="{ marginLeft: '8px' }"
          @click="lookOver(record)"
        >
          <a-icon type="book" />预览
        </a-button>
      </template>
    </a-table>
    <a-drawer
      :title="drawerTitle"
      placement="right"
      :closable="true"
      @close="materielVisible = false"
      :visible="materielVisible"
      :width="1500"
      :destroyOnClose="true"
    >
      <a-row>
        <a-col :span="10">
          <a-form :form="form" layout="vertical" @submit="complete">
            <a-form-item label="物料名称：">
              <a-input
                v-decorator="[
                  'name',
                  {
                    rules: [
                      {
                        required: true,
                        max: 100,
                        message: '物料名称必填,且不超过100个字',
                      },
                    ],
                    validateTrigger: 'blur',
                  },
                ]"
                placeholder="请输入物料名称"
              />
            </a-form-item>
            <a-form-item label="id" style="display: none">
              <a-input v-decorator="['id']" />
            </a-form-item>
            <a-form-item label="图片文件：">
              <a-row :gutter="15">
                <a-col :span="18">
                  <a-input
                    v-decorator="[
                      'picture',
                      {
                        rules: [{ required: true, message: '图片url地址必填' }],
                      },
                    ]"
                    style="width: 100%"
                    placeholder="请从云图库选择图片"
                    read-only
                  />
                </a-col>
                <a-col :span="6">
                  <a-button type="primary" @click="onPic">
                    打开云图库<a-icon type="folder-open" />
                  </a-button>
                </a-col>
              </a-row>
            </a-form-item>
            <label for="" style="margin-bottom: 10px">图片尺寸：</label>
            <a-row>
              <a-col :span="12">
                <a-form-item
                  label="宽度："
                  :label-col="{ span: 6 }"
                  :wrapper-col="{ span: 10 }"
                >
                  <a-input
                    size="small"
                    @blur="pictureSize('width')"
                    v-decorator="[
                      'width',
                      {
                        rules: [
                          {
                            required: true,
                            message: '图片宽度必填',
                          },
                          {
                            validator: imageSize,
                          },
                        ],
                        initialValue: 300,
                      },
                    ]"
                    style="width: 80px"
                  />
                  px
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  label="高度："
                  :label-col="{ span: 6 }"
                  :wrapper-col="{ span: 10 }"
                >
                  <a-input
                    size="small"
                    @blur="pictureSize('height')"
                    v-decorator="[
                      'height',
                      {
                        rules: [
                          { required: true, message: '图片高度必填' },
                          {
                            validator: imageSize,
                          },
                        ],
                        initialValue: 40,
                      },
                    ]"
                    style="width: 80px"
                  />
                  px
                </a-form-item>
              </a-col>
            </a-row>

            <!-- <a-form-item label="目标窗口：">
              <a-radio-group
                name="radioGroup"
                v-decorator="[
                  'target',
                  {
                    initialValue: '1'
                  }
                ]"
              >
                <a-radio :value="'1'">新窗口</a-radio>
                <a-radio :value="'2'">原窗口</a-radio>
              </a-radio-group>

              <a-tooltip
                title="即点击广告物料后，将在新窗口/原窗口打开广告物料页面"
              >
                <a-icon
                  type="question-circle"
                  theme="twoTone"
                  twoToneColor="#eb2f96"
                />
              </a-tooltip>
            </a-form-item> -->
            <a-form-item label="点击链接：">
              <a-input
                v-decorator="[
                  'src',
                  {
                    rules: [
                      {
                        required: true,
                        message: '点击链接必填,若不需要链接请填入#',
                      },
                    ],
                    initialValue: '#',
                  },
                ]"
                placeholder="请输入点击链接"
                :max-length="3000"
                :disabled="agree"
              >
                <!-- <a-select
                  slot="addonBefore"
                  style="width: 90px"
                  v-decorator="[
                    'http',
                    {
                      initialValue: 'http://'
                    }
                  ]"
                  @change="agreement"
                >
                  <a-select-option value="http://">http://</a-select-option>
                  <a-select-option value="https://">https://</a-select-option>
                  <a-select-option value="0">无链接</a-select-option>
                </a-select> -->
              </a-input>
            </a-form-item>
            <a-form-item label="图片描述：">
              <a-textarea
                :rows="4"
                v-decorator="[
                  'alt',
                  {
                    rules: [{ max: 100, message: '最多输入100个字符' }],
                  },
                ]"
                placeholder="请输入图片描述"
              />
            </a-form-item>
            <a-form-item>
              <a-button type="primary" html-type="submit"> 完成 </a-button>
              <a-button
                :style="{ marginLeft: '8px' }"
                @click="materielVisible = false"
              >
                取消
              </a-button>
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :span="14">
          <div class="preview-box">
            <img
              :src="preview.imgUrl"
              alt=""
              :width="preview.width"
              :height="preview.height"
              v-if="preview.imgUrl != ''"
            />
            <a-empty v-else />
          </div>
        </a-col>
      </a-row>
    </a-drawer>

    <a-modal
      title="请选择需要插入的图片"
      :visible="pictureVisible"
      width="1140px"
      :footer="null"
      :bodyStyle="{ padding: 0 }"
      @cancel="pictureVisible = false"
      :zIndex="1001"
    >
      <div style="width: 100%; height: 50px; padding: 10px 20px">
        搜索：
        <a-input-search
          placeholder="请输入图片标题"
          v-model="imgParam.keyword"
          style="width: 400px; margin-right: 10px"
          @search="onImgSearch"
        />
        <a-button @click="resetImg()" style="margin-right: 10px">重置</a-button>
        <a-button type="primary" @click="uploadImg()">
          上传至云图库<a-icon type="cloud-upload" />
        </a-button>
        <a-upload-dragger
          name="file"
          accept="image/*"
          :headers="headers"
          :beforeUpload="beforeUpload"
          style="display: none"
        >
          <div ref="imgupload">
            <a-icon type="inbox" />
          </div>
        </a-upload-dragger>
      </div>
      <div class="picture-area">
        <div class="picture-list">
          <a-spin :spinning="loadingMore" size="large">
            <div class="lists">
              <ul>
                <li
                  v-for="(item, index) in picLists"
                  :key="index"
                  class="pic-lists"
                  @click="insertImg(item.url)"
                >
                  <div class="imgs">
                    <img :src="item.url + '/thumb_400'" alt="" />
                  </div>
                  <div class="title">{{ item.filename }}</div>
                </li>
              </ul>
              <div class="more">
                <a-button @click="loadmore" v-if="!loadingMore">
                  加载更多
                </a-button>
              </div>
            </div>
          </a-spin>
        </div>
      </div>
    </a-modal>
    <a-modal
      title="预览物料"
      :visible="previewVisible"
      :footer="null"
      :bodyStyle="{ padding: 0 }"
      @cancel="previewVisible = false"
      :zIndex="1005"
      :width="previewImg.windowH + 'px'"
    >
      <div style="text-align: center; padding: 20px">
        <img
          :src="previewImg.imgUrl"
          :alt="previewImg.alt"
          :width="previewImg.width"
          :height="previewImg.height"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: '广告物料名称',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '广告物料缩略图',
    dataIndex: 'picture',
    width: '300px',
    scopedSlots: { customRender: 'picture' },
    align: 'center'
  },
  {
    title: '尺寸',
    scopedSlots: { customRender: 'size' },
    align: 'center',
    with: '150px'
  },
  // {
  //   title: '窗口类型',
  //   dataIndex: 'target',
  //   scopedSlots: { customRender: 'target' },
  //   align: 'center'
  // },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center'
  }
];

export default {
  components: {},
  data() {
    return {
      drawerTitle: '广告物料',
      data: [], //表格数据
      pagination: {},
      loading: true,
      picLists: [], //云图片
      imgParam: {
        page: 0,
        keyword: ''
      },
      headers: {
        //上传图片至云图库的请求头
        Authorization: window.localStorage.getItem('token')
      },
      columns,
      materielVisible: false, //编辑物料开关
      pictureVisible: false, //云图片modal开关
      previewVisible: false, //预览modal
      form: this.$form.createForm(this),
      preview: {
        //预览
        imgUrl: '',
        width: 300,
        height: 40
      },
      previewImg: {
        imgUrl: '',
        width: 300,
        height: 40,
        alt: '',
        windowH: 400
      },
      loadingMore: false,
      limit: 10,
      agree: false
    };
  },

  computed: {},

  watch: {},

  methods: {
    //判断图片尺寸是否为number
    imageSize(rule, value, callback) {
      let reg = /^[0-9]+(.[0-9]{2})?$/;
      if (!reg.test(value)) {
        callback('请输入最多两位小数的正数');
      } else {
        callback();
      }
    },
    //物料列表
    fetch(params = {}) {
      this.$http.post('/api/ad/goodslist', params).then(res => {
        const pagination = { ...this.pagination };
        if (res.data.state == 200) {
          // pagination.total = data.totalCount;
          pagination.total = 10 * res.data.pages;
          this.loading = false;
          this.data = res.data.data;
        } else {
          this.loading = false;
          pagination.total = 0;
          this.data = [];
        }
        this.pagination = pagination;
      });
    },

    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.loading = true;
      this.fetch({
        limit: this.limit,
        page: pagination.current
      });
    },
    //搜索物料
    onSerch(value, event) {
      this.fetch({
        limit: this.limit,
        name: value
      });
    },
    //编辑广告
    editAdv(type, record) {
      this.materielVisible = true;
      if (type === 'edit') {
        this.$nextTick(function () {
          // if (record.src == '#') {
          //   this.form.setFieldsValue({
          //     src: '#',
          //     http: '0'
          //   });
          //   this.agree = true;
          // } else {
          //   let src = record.src.split('://');
          //   let http = 'http';
          //   if (src[0] != http) {
          //     http = 'https';
          //   }
          //   this.form.setFieldsValue({
          //     src: src[1],
          //     http: http + '://'
          //   });
          //   this.agree = false;
          // }
          this.form.setFieldsValue({
            id: record.id ? record.id : '',
            name: record.name,
            picture: record.picture,
            width: record.width,
            height: record.height,
            alt: record.alt ? record.alt : '',
            src: record.src
          });
          this.preview.imgUrl = record.picture;
          this.preview.width = record.width;
          this.preview.height = record.height;
          this.drawerTitle = '编辑广告物料';
          this.pictureSize();
        });
      } else {
        this.preview.imgUrl = '';
        this.preview.width = 300;
        this.preview.height = 40;
        this.drawerTitle = '新建广告物料';
      }
    },
    //获取云图片
    getPicLists() {
      this.$http.post('/api/AliyunOss/lists', this.imgParam).then(res => {
        if (res.data.state == 200) {
          for (let i in res.data.data) {
            this.picLists.push(res.data.data[i]);
          }
          this.loadingMore = false;
        }
      });
    },
    //云图库搜索图片
    onImgSearch() {
      this.imgParam.page = 1;
      this.picLists = [];
      this.getPicLists();
    },
    //云图片向下滚动时加载图片
    loadmore() {
      const imgParam = { ...this.imgParam };
      imgParam.page += 1;
      this.imgParam = imgParam;
      this.loadingMore = true;
      this.getPicLists();
    },
    uploadImg() {
      this.$refs.imgupload.click();
    },
    //重置
    resetImg() {
      this.imgParam.keyword = '';
      this.imgParam.page = 1;
      this.picLists = [];
      this.getPicLists();
    },
    //获取点击的图片的url
    insertImg(src) {
      this.form.setFieldsValue({
        picture: src
      });
      this.preview.imgUrl = src;
      this.pictureVisible = false;
    },
    async beforeUpload(file) {
      let res = await this.$http.post(
        'https://openapi.ycrmt.cn/aliyun/index/Imgesupload'
      );
      let data = res.data.data;
      let client = new this.$OSS({
        region: data.config.region,
        accessKeyId: data.result.Credentials.AccessKeyId,
        accessKeySecret: data.result.Credentials.AccessKeySecret,
        stsToken: data.result.Credentials.SecurityToken,
        bucket: data.config.bucket
      });
      let options = {
        callback: data.callback
      };
      options.callback.customValue.filename = file.name.substring(
        0,
        file.name.lastIndexOf('.')
      ); //原文件名称
      let date = new Date();
      let year = this.$moment().format('YYYY');
      let month = this.$moment().format('MM');
      let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let result = await client.put(
        data.path +
        year +
        '/' +
        month +
        '/' +
        this.$md5(date) +
        '.' +
        fileExtension,
        file,
        options
      );
      if (result.data.errno === 0) {
        this.$message.success('文件上传成功');
        this.busy = false;
        this.picLists = [];
        this.imgParam.page = 1;
        this.getPicLists();
      } else {
        this.$$message.error('文件上传失败');
      }
    },
    //上传云图片
    handleChange(info) {
      if (info.file.status === 'done') {
        this.$message.success('文件上传成功');
        this.picLists = [];
        this.imgParam.page = 1;
        this.getPicLists();
      } else if (info.file.status === 'error') {
        this.$message.success('文件上传失败');
      }
    },
    //设置图片宽高
    pictureSize(type) {
      let err = this.form.getFieldsError(['width', 'height']);
      let width = Number(this.form.getFieldValue('width'));
      let height = Number(this.form.getFieldValue('height'));
      let preview = { ...this.preview };
      if (err.width == undefined && err.height == undefined) {
        if (width <= 300 && height <= 250) {
          preview.width = width;
          preview.height = height;
        } else if (width > 300 && height <= 250) {
          preview.width = 300;
          let proPortionH = (300 / width) * height;
          preview.height = proPortionH;
        } else if (width <= 300 && height > 250) {
          preview.height = 250;
          let proPortionW = (250 / height) * width;
          preview.width = proPortionW;
        } else if (width > 300 && height > 250) {
          if (width > height) {
            preview.width = 300;
            preview.height = 250 * (height / width);
          } else if (width < height) {
            preview.height = 250;
            preview.width = 300 * (width / height);
          } else if (width === height) {
            preview.height = 250;
            preview.width = 250;
          }
        }
        this.preview = preview;
      }
    },
    ratioHeight(height) {
      let H = Number(height);
      if (height <= 60) {
        return H;
      } else {
        return 40;
      }
    },
    //上传物料
    complete(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {
            id: values.id ? values.id : '',
            name: values.name,
            picture: values.picture,
            width: values.width,
            height: values.height,
            alt: values.alt ? values.alt : '',
            src: values.src
          };
          // if (values.http == 0) {
          //   params.src = '#';
          // } else {
          //   params.src = values.http + values.src;
          // }
          this.$http.post('/api/ad/goodsupdate', params).then(res => {
            if (res.data.state == 200) {
              if (params.id == '') {
                this.$message.success('添加成功');
              } else {
                this.$message.success('编辑成功');
              }
              this.fetch({ limit: this.limit });
              this.materielVisible = false;
            } else {
              this.$message.error('操作失败，请重试');
            }
          });
        }
      });
    },
    //删除物料
    del(id) {
      this.$http
        .post('/api/ad/goodsdel', {
          ids: id
        })
        .then(res => {
          if (res.data.state == 200) {
            this.$message.success('删除成功');
            this.fetch({ limit: this.limit });
          } else {
            this.$message.error('操作失败，请重试');
          }
        });
    },
    //预览物料
    lookOver(record) {
      // let routeData = this.$router.resolve({
      //   name: "searchGoods",
      // });
      // window.open(routeData.href, '_blank');
      this.previewImg.imgUrl = record.picture;
      this.previewImg.width = record.width;
      this.previewImg.height = record.height;
      this.previewImg.alt = record.alt;
      this.previewImg.windowH = Number(record.width) + 80;
      this.previewVisible = true;
    },
    onPic() {
      this.pictureVisible = true;
    }
  },
  created() { },
  mounted() {
    this.fetch({ limit: this.limit });
    this.getPicLists();
  }
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 60px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}
.screen-option {
  margin-right: 10px;
  margin-bottom: 10px;
}
.ant-form-item {
  margin-bottom: 8px;
}
.picture-area {
  /*height: 400px;*/
}
.picture-list {
  height: 600px;
  /*min-height: 600px;*/
  overflow-y: auto;
}

.picture-list .lists {
  margin: 0 10px;
}
.picture-list .lists ul li {
  float: left;
  width: 205px;
  height: 175px;
  text-align: center;
  cursor: pointer;
  padding: 0 10px;
  margin-bottom: 10px;
}
.picture-list .lists ul li.pic-lists:hover {
  background-color: #f2f6fc;
}
.picture-list .lists .imgs {
  height: 145px;
  line-height: 145px;
}
.picture-list .lists .title {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*height:28px;*/
  line-height: 28px;
  font-size: 14px;
  color: #606266;
}
.picture-list .lists ul li:hover .title {
  color: #409eff;
}
.picture-list .lists ul li img {
  vertical-align: middle;
  max-width: 145px;
  max-height: 145px;
  border-radius: 5px;
}
.preview-box {
  position: absolute;
  width: 352px;
  height: 302px;
  padding: 25px;
  border: 1px solid #ddd;
  right: 185px;
  overflow: hidden;
}
.more {
  width: 90%;
  margin: 10px auto;
}
.more > button {
  width: 100%;
}
</style>
